// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__snEN5","city":"styles_city__wyBEK","school":"styles_school__eKdAC","dates":"styles_dates___R8O4","description":"styles_description__alsZn"};